import { cx } from "@/platform/ui/primitives/index.js";

export function WaypointMark({ className }: { className?: string }) {
  return (
    <span
      className={cx(
        "inline-flex items-center justify-center rounded-xl border border-accent bg-surface text-accent shadow-[0_0_28px_rgba(124,92,255,0.18)]",
        className,
      )}
      aria-hidden="true"
    >
      <svg viewBox="0 0 64 64" className="h-[72%] w-[72%]" fill="none">
        <path d="M32 15 38 27 50 32 38 37 32 49 26 37 14 32 26 27 32 15Z" fill="currentColor" />
        <circle cx="44" cy="18" r="3.25" fill="currentColor" />
      </svg>
    </span>
  );
}

export function WaypointLogo({
  showText = true,
  markClassName,
}: {
  showText?: boolean;
  markClassName?: string;
}) {
  return (
    <div className="flex min-w-0 items-center gap-3">
      <WaypointMark className={cx("h-9 w-9 flex-none", markClassName)} />
      {showText && (
        <div className="min-w-0">
          <div className="truncate text-sm font-extrabold leading-none tracking-tight text-ink">
            Waypoint
          </div>
          <div className="mt-1 text-[9px] font-semibold uppercase tracking-[0.22em] text-faint">
            Track · Decide · Act
          </div>
        </div>
      )}
    </div>
  );
}
